import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateSub',
    standalone: true,
})
export class DateSubPipe implements PipeTransform {
    transform(date: Date | string | null | undefined): Date | null {
        if (!date) {
            return null;
        }

        const dateObj = typeof date === 'string' ? new Date(date) : new Date(date);

        if (isNaN(dateObj.getTime())) {
            return null;
        }

        const result = new Date(dateObj);
        result.setDate(result.getDate() - 1);

        return result;
    }
}
